<template>

    <div class="page-icon">
        <i v-if="!loading" :class="symbol"></i>
        <v-loader v-else size="md" type="white" />
    </div>

</template>

<style scoped lang="scss">

    .page-icon {
        align-items: center;
        background-color: $color-primary;
        border-radius: 5px;
        color: #fff;
        display: flex;
        font-size: 18px;
        height: 40px;
        justify-content: center;
        line-height: normal;
        margin-right: 10px;
        width: 40px;
    }

</style>

<script>

export default {

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        symbol: {
            type: String,
            required: true,
        },
    },

}

</script>
